var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12718 5.41667H7.86293C8.36576 5.41667 8.63293 4.82167 8.29868 4.44542L4.93109 0.656666C4.87647 0.59501 4.80938 0.545648 4.73427 0.511843C4.65915 0.478037 4.57772 0.460556 4.49534 0.460556C4.41297 0.460556 4.33154 0.478037 4.25642 0.511843C4.1813 0.545648 4.11422 0.59501 4.05959 0.656666L0.690842 4.44542C0.356592 4.82167 0.623759 5.41667 1.12718 5.41667ZM4.05901 11.3428C4.11363 11.4044 4.18072 11.4538 4.25584 11.4876C4.33095 11.5214 4.41239 11.5389 4.49476 11.5389C4.57713 11.5389 4.65857 11.5214 4.73368 11.4876C4.8088 11.4538 4.87588 11.4044 4.93051 11.3428L8.29809 7.554C8.63293 7.17833 8.36576 6.58333 7.86234 6.58333H1.12718C0.624343 6.58333 0.357176 7.17833 0.691426 7.55458L4.05901 11.3428Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDisable);
export default __webpack_public_path__ + "static/media/sortDisable.1d5824604671d0fcc24aa9298e01e880.svg";
export { ForwardRef as ReactComponent };